import FolderIcon from '@/assets/icons/folder.svg?react'
import { Checkbox } from '@/components'

import { IFile } from '../fs'
import { FileIcon } from './FileIcon'

interface GalleryItemProps {
  file: IFile
  selected: boolean
  onSelect: (checked: boolean) => void
  onClick: () => void
}

export function GalleryItem({ file, selected, onSelect, onClick }: GalleryItemProps) {
  return (
    <div
      className="relative flex h-[120px] w-[88px] cursor-pointer flex-col items-center rounded-lg bg-neutral-100 p-2"
      onClick={onClick}
    >
      {/* Checkbox */}
      <div
        className="absolute left-1 top-1 z-10"
        onClick={(e) => {
          e.stopPropagation()
          onSelect(!selected)
        }}
      >
        <Checkbox
          checked={selected}
          onChange={onSelect}
          inputClassName="w-4 h-4"
          checkedBgColor="bg-btn-secondary"
          checkedBorderColor="border-none"
          checkIconColor="text-white"
        />
      </div>

      {/* Icon */}
      <div className="flex items-center justify-center p-2">
        <div className="flex h-14 w-14 items-center justify-center overflow-hidden rounded-md">
          {file.isDir ? (
            <FolderIcon className="h-14 w-14 text-warning" />
          ) : (
            <FileIcon ext={file.ext} className="h-14 w-14" />
          )}
        </div>
      </div>

      {/* Filename */}
      <p className="line-clamp-2 w-full break-all text-center text-xs font-semibold text-primary">
        {file.name}
      </p>
    </div>
  )
}
